
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11521',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11521",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.214",
  "data-fetching-client": "static-1.9465",
  "foundations-components": "static-1.7497",
  "foundations-components-legacy": "static-1.522",
  "foundations-theming": "static-1.4196",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7791",
  "hub-http-shared-msw-handlers": "static-1.9450",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11209",
  "I18n": "static-7.1564",
  "jasmine-runner": "static-1.6259",
  "marketplace-storefront-base": "static-1.11581",
  "quartz": "static-1.6712",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16433",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2648",
  "reporting-testing-lib": "static-1.8392",
  "settings-ui-lib": "static-1.12308",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6705",
  "ui-addon-i18n": "static-1.10923",
  "ui-addon-react-router-dom": "static-1.9334",
  "unified-auth": "static-1.188",
  "unified-auth-core-lib": "static-1.469",
  "usage-tracker": "static-1.7118",
  "usage-tracker-core": "static-1.6968",
  "customer-data-property-utils": "static-1.7862",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15375",
  "marketplace-ui-common": "static-1.18901",
  "property-management-iframe": "static-1.12284",
  "quartz-config": "static-1.490",
  "quartz-core": "static-1.5931",
  "quartz-routing": "static-1.142",
  "quick-fetch": "static-1.3722",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4418",
  "ts-schema": "static-1.3890",
  "ui-universal-auth": "static-1.8674",
  "UIComponents": "static-3.8156",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3213",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2989",
  "quartz-webpack": "static-1.2936",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3766",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4623",
  "foundations-theming-specialty": "static-1.1912",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9215",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5160",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1155",
  "ui-fonts": "static-1.471",
  "ui-images": "static-2.1087",
  "bend-plugin-foundations-theming": "static-1.2679",
  "foundations-theming-base": "static-1.3181",
  "stylex": "static-1.27",
  "HeadJS": "static-2.706",
  "hs-test-utils-bend-plugin": "static-1.2902",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4114",
  "ai-components-ui-library": "static-1.8316",
  "ai-rendering-library": "static-1.9263",
  "chirp-fetch": "static-1.1669",
  "connections-embed-lib": "static-1.607",
  "copilot-toolkit": "static-1.10493",
  "laboratory-lib": "static-3.6948",
  "marketplace-embed": "static-1.21453",
  "marketplace-ui-details": "static-1.8797",
  "marketplace-ui-reviews": "static-1.18857",
  "marketplace-ui-tracking": "static-1.13072",
  "sanitize-text": "static-1.7925",
  "ui-addon-video-player": "static-1.8481",
  "usage-tracker-multi": "static-1.5532",
  "usage-tracker-session-replay": "static-1.4804",
  "wootric-nps": "static-1.6769",
  "apollo-link-hub-http": "static-2.4434",
  "immer": "static-1.33",
  "immerable": "static-1.3940",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2385",
  "reporting-data": "static-1.66459",
  "cssUtils": "static-1.726",
  "flux-actions": "static-1.306",
  "HubStyle": "static-2.11517",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9997",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10159",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7108",
  "icons": "static-2.620",
  "marketplace-ui-apps-core": "static-1.17434",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4309",
  "foundations-components-test-utils": "static-1.4980",
  "quartz-i18n": "static-1.387",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3517",
  "customer-data-objects": "static-1.7433",
  "property-translator": "static-1.5199",
  "frontend-preferences-client": "static-1.7711",
  "hs-promise-utils": "static-1.5378",
  "hubspot-apollo-client": "static-1.4666",
  "integrations-error-boundary-lib": "static-1.12790",
  "integrations-tracking-lib": "static-1.5373",
  "native-integrations-shared-strings": "static-1.7574",
  "reselect": "static-2.16",
  "sanitize": "static-1.4261",
  "superstore": "static-1.4557",
  "ui-shepherd-react": "static-3.9931",
  "ai-settings-ui-library": "static-1.7425",
  "hub-http-janus": "static-1.789",
  "hubspotter-http": "static-1.4465",
  "immutable-less": "static-1.4439",
  "marketplace-ui-client-types": "static-1.16308",
  "nav-meta": "static-1.28866",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10022",
  "ui-addon-upgrades": "static-9.17633",
  "inbound-db-properties-service-client": "static-1.3662",
  "property-management-common": "static-1.4571",
  "ui-addon-iframeable": "static-1.8831",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.479",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.387",
  "quartz-head": "static-1.377",
  "quartz-test": "static-1.387",
  "quartz-tracking": "static-1.91",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2933",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20254",
  "ContentUtils": "static-1.67587",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2270",
  "customer-data-filters-ui": "static-1.38865",
  "customer-data-objects-ui-components": "static-1.12792",
  "customer-data-reference-ui-components": "static-1.12929",
  "embedded-academy-lib": "static-1.13464",
  "ExportDialog": "static-6.10174",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40627",
  "reporting-snowflake": "static-1.55077",
  "reporting-ui-components": "static-2.63730",
  "reporting-visualizations": "static-1.58535",
  "ui-addon-teams": "static-1.21223",
  "magpie-lib": "static-1.5380",
  "magpie-types": "static-1.4840",
  "simple-logging-lib": "static-1.2836",
  "navigation-components": "static-1.17229",
  "ai-studio-lib": "static-1.10966",
  "developer-experience-shared-components": "static-1.10251",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7774",
  "ui-tool-access": "static-1.9931",
  "usage-based-billing-components-lib": "static-1.7971",
  "usage-tracker-anonymous": "static-1.5535",
  "usage-tracker-public": "static-1.6929",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3404",
  "persist-promise": "static-1.3492",
  "reference-resolvers": "static-1.7947",
  "ui-extensibility-client-types": "static-1.3732",
  "hubspot-apollo-cache": "static-1.125",
  "universal-page-editor-lib": "static-1.2786",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2155",
  "merchandise-lib": "static-1.258",
  "atom": "static-1.4856",
  "purchase-motions-components": "static-1.5464",
  "salesImages": "static-1.520",
  "batch-promise": "static-1.1335",
  "crm-component-utils": "static-1.38455",
  "crm-properties-common-lib": "static-1.5658",
  "framework-data-schema-resolvers": "static-1.6657",
  "reference-resolvers-lite": "static-1.7879",
  "navigation-messaging": "static-1.6556",
  "hubspotter-http-shared-msw-handlers": "static-1.9448",
  "cms-field-types": "static-1.4591",
  "content-icons-ui": "static-1.2148",
  "conversations-skeleton-state": "static-1.7034",
  "crm-message-bus": "static-1.42329",
  "customer-data-filters-ui-msw-helpers": "static-1.21299",
  "customer-data-ui-utilities": "static-1.9611",
  "FormUrlGenerator": "static-2.4516",
  "framework-builder-read-service-client": "static-1.3820",
  "framework-data-schema-quick-fetch": "static-1.6562",
  "multi-account-reference-resolvers": "static-1.759",
  "onboarding-tours": "static-1.16238",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13001",
  "academy-common-lib": "static-1.12924",
  "content-assistance-lib": "static-1.7429",
  "dashboard-lib": "static-1.80580",
  "file-manager-components": "static-1.22854",
  "getting-started-shared-tasks": "static-1.17850",
  "hubspot-prosemirror": "static-1.17574",
  "hubspot-prosemirror-plugins": "static-1.17566",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19450",
  "share-with-third-party-component-lib": "static-1.8478",
  "ui-addon-draggable": "static-3.4552",
  "ui-asset-management-lib": "static-1.10691",
  "ui-business-units-lib": "static-1.8812",
  "user-context": "static-1.4882",
  "growth-payments-core": "static-1.24696",
  "reporting-plugins": "static-1.9966",
  "reporting-reports": "static-1.66137",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.511",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28832",
  "react-codemirror": "static-1.10413",
  "apps-service-types": "static-1.3665",
  "oauth-service-types": "static-1.4028",
  "onboarding-scopes": "static-1.6249",
  "onboarding-tours-client": "static-1.4452",
  "platform-infra-nav-components": "static-1.7479",
  "subscription-experience-data-types": "static-1.14572",
  "crm-record-cards-service-types": "static-1.3439",
  "location-customization-utils-lib": "static-1.8524",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4301",
  "nav-client-types": "static-1.2142",
  "purchase-motions-api": "static-1.5467",
  "signup-constants": "static-1.18362",
  "signup-ui-url-generator": "static-2.7854",
  "trials-service-types": "static-1.3702",
  "card-properties-lib": "static-1.43485",
  "crm-actions": "static-1.6086",
  "crm-cards-data": "static-1.1184",
  "crm-cards-sdk": "static-1.42879",
  "customer-data-properties": "static-1.50768",
  "customer-data-properties-shared-msw-handlers": "static-1.8777",
  "customer-data-tracking": "static-1.6667",
  "conditional-properties-service-client": "static-1.3610",
  "crm-pipelines-api-client-types": "static-1.3951",
  "multi-currency-client-types": "static-1.3504",
  "external-options-client-types": "static-1.3971",
  "react-dnd-compat": "static-1.4408",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5138",
  "growth-onboarding-confetti": "static-1.2856",
  "growth-onboarding-next-action-utils": "static-1.1286",
  "onboarding-tours-utils": "static-1.304",
  "ui-shepherd-tracker": "static-1.7312",
  "academy-service-client": "static-1.3467",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27912",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8171",
  "video-components-external": "static-1.10526",
  "video-data-lib": "static-1.34184",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8355",
  "payment-link-components": "static-1.22909",
  "ui-addon-emoji-picker": "static-1.9675",
  "EmailSignatureEditor": "static-1.23883",
  "viral-links-lib": "static-1.6819",
  "data-token-picker": "static-1.16022",
  "FileManagerLib": "static-1.38494",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5031",
  "getting-started-shared-tasks-store": "static-1.16968",
  "campaign-roi-lib": "static-1.8236",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.176",
  "eligibility-engine-service-types": "static-1.2983",
  "crm_data": "static-4.91176",
  "crm-links": "static-1.6049",
  "customer-data-sidebar": "static-2.45384",
  "enrichment-properties-lib": "static-1.14980",
  "crm-fe-perf": "static-1.22691",
  "calling-global-api": "static-1.63611",
  "calling-internal-common": "static-1.31077",
  "calling-lifecycle-internal": "static-1.64993",
  "calling-lifecycle-messages": "static-1.57287",
  "commerce-products-lib": "static-1.8828",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.463",
  "inbounddb-objects-service-types": "static-1.4036",
  "meetings-icalendar-utils-lib": "static-1.419",
  "object-builder-ui-client": "static-1.47928",
  "pipeline-validation-client-types": "static-1.3773",
  "property-value-citations": "static-1.1382",
  "pulse": "static-1.291",
  "smart-property-lib": "static-1.5862",
  "tiered-pricing": "static-1.810",
  "ui-addon-form-validation": "static-1.10780",
  "growth-onboarding-feedback-components": "static-1.6371",
  "content-media-composition-data-lib": "static-1.11412",
  "content-media-compositions": "static-2.15419",
  "media-bridge-lib": "static-1.18544",
  "commerce-tours-lib": "static-1.5699",
  "growth-onboarding-reliability": "static-1.4873",
  "sales-checkout-service-client": "static-1.3462",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21288",
  "sales-email-signature-service-client": "static-1.3631",
  "audio-components": "static-1.5593",
  "FileManagerCore": "static-1.38353",
  "FileManagerImages": "static-1.36005",
  "video-components": "static-1.12529",
  "crm_universal": "static-1.21641",
  "customer-data-email": "static-1.17649",
  "calling-error-reporting": "static-1.31083",
  "card-payment-highlight-lib": "static-1.36472",
  "card-subscription-highlight-lib": "static-1.38827",
  "commerce-billing-lib": "static-1.18470",
  "commerce-contract-lib": "static-1.11123",
  "customer-data-content": "static-1.26851",
  "invoices-highlight-card-lib": "static-1.53982",
  "orders-highlight-card-lib": "static-1.20839",
  "products-highlight-card-lib": "static-1.17112",
  "project-storage": "static-1.4518",
  "quotes-highlight-card-lib": "static-1.71122",
  "breeze-intelligence-kit": "static-1.5302",
  "crm-source-interpretation-lib": "static-1.5115",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9533",
  "policy-lib": "static-1.6569",
  "shared-worker-versioning": "static-1.10823",
  "calling-usage-tracker": "static-1.6325",
  "voice-sms-access-library": "static-1.210",
  "products-iframe-lib": "static-1.7280",
  "products-ui-components-shared-msw-handlers": "static-1.9832",
  "directed-graph": "static-1.723",
  "event-emitter": "static-1.733",
  "react-tinymce": "static-1.54584",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9596",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53710",
  "tinymce-plugins": "static-1.56824",
  "tinymce-themes": "static-1.55680",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4319",
  "video-embed": "static-1.35018",
  "social-insights-client-types": "static-1.21289",
  "sequences-lib": "static-1.7671",
  "ui-gdpr-components": "static-1.10133",
  "commerce-shared-components-lib": "static-1.17884",
  "commerce-subscription-lib": "static-1.36404",
  "commerce-tools-ui-lib": "static-1.9762",
  "utility-belt": "static-1.2328",
  "payments-enrollment-embed-lib": "static-1.21968",
  "products-ui-components": "static-1.39347",
  "quotes-client-types": "static-1.37210",
  "quotes-ui-lib": "static-1.79841",
  "SalesContentIndexUI": "static-3.8882",
  "accounting-integrations-ui-components": "static-1.6704",
  "invoices-ui-lib": "static-1.53998",
  "commerce-products-api": "static-1.1939",
  "SafeStorage": "static-1.4190",
  "invoices-iframe-lib": "static-1.56056",
  "quotes-modal-lib": "static-1.101798",
  "calling-orchestration-schema": "static-1.34987",
  "sales-views-client-types": "static-1.4078",
  "hub-http-contrib": "static-1.2831",
  "interframe": "static-3.4577",
  "tinymce-data": "static-1.39795",
  "ui-addon-sales-email": "static-1.4999",
  "layout-dnd-components": "static-1.12011",
  "layout-dnd-utils": "static-1.10986",
  "ui-brand-identity-lib": "static-1.13826",
  "NamespacedHubStyle": "static-2.8883",
  "outpost": "static-1.3991",
  "sequences-client-types-lib": "static-1.7528",
  "customer-data-associations": "static-1.7123",
  "framework-data-table": "static-2.11384",
  "customer-data-rte": "static-1.32417",
  "cv-backend-services": "static-1.1499",
  "growth-onboarding-empty-states": "static-1.5346",
  "InboxConnectUtils": "static-4.14192",
  "payments-post-enroll-local-storage-lib": "static-1.4898",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7112",
  "commerce-permissions": "static-1.539",
  "commerce-tax-lib": "static-1.299",
  "property-description-translator": "static-1.3645",
  "FireAlarmUi": "static-1.4316",
  "sales-templates-service-types-lib": "static-1.3979",
  "commerce-analytics-service-client": "static-1.3450",
  "totals-ui-components": "static-1.22968",
  "ContentData": "static-1.67662",
  "layout-data-lib": "static-1.9311",
  "deal-intel-decorators": "static-1.1215",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27685",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3624",
  "advanced-menus-core": "static-1.14795",
  "advanced-menus-lib": "static-1.11771",
  "ui-memberships-settings-lib": "static-1.33395",
  "deal-intel-utils": "static-1.1219",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14794",
  "simple-menus-lib": "static-1.16311"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11521",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.214",
  "data-fetching-client": "/data-fetching-client/static-1.9465",
  "foundations-components": "/foundations-components/static-1.7497",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.522",
  "foundations-theming": "/foundations-theming/static-1.4196",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7791",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9450",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11209",
  "I18n": "/I18n/static-7.1564",
  "jasmine-runner": "/jasmine-runner/static-1.6259",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11581",
  "quartz": "/quartz/static-1.6712",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16433",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2648",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8392",
  "settings-ui-lib": "/settings-ui-lib/static-1.12308",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6705",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10923",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9334",
  "unified-auth": "/unified-auth/static-1.188",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.469",
  "usage-tracker": "/usage-tracker/static-1.7118",
  "usage-tracker-core": "/usage-tracker-core/static-1.6968",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7862",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15375",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18901",
  "property-management-iframe": "/property-management-iframe/static-1.12284",
  "quartz-config": "/quartz-config/static-1.490",
  "quartz-core": "/quartz-core/static-1.5931",
  "quartz-routing": "/quartz-routing/static-1.142",
  "quick-fetch": "/quick-fetch/static-1.3722",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4418",
  "ts-schema": "/ts-schema/static-1.3890",
  "ui-universal-auth": "/ui-universal-auth/static-1.8674",
  "UIComponents": "/UIComponents/static-3.8156",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3213",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2989",
  "quartz-webpack": "/quartz-webpack/static-1.2936",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3766",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4623",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1912",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9215",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5160",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1155",
  "ui-fonts": "/ui-fonts/static-1.471",
  "ui-images": "/ui-images/static-2.1087",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2679",
  "foundations-theming-base": "/foundations-theming-base/static-1.3181",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.706",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2902",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4114",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8316",
  "ai-rendering-library": "/ai-rendering-library/static-1.9263",
  "chirp-fetch": "/chirp-fetch/static-1.1669",
  "connections-embed-lib": "/connections-embed-lib/static-1.607",
  "copilot-toolkit": "/copilot-toolkit/static-1.10493",
  "laboratory-lib": "/laboratory-lib/static-3.6948",
  "marketplace-embed": "/marketplace-embed/static-1.21453",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8797",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18857",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13072",
  "sanitize-text": "/sanitize-text/static-1.7925",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8481",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5532",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4804",
  "wootric-nps": "/wootric-nps/static-1.6769",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4434",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3940",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2385",
  "reporting-data": "/reporting-data/static-1.66459",
  "cssUtils": "/cssUtils/static-1.726",
  "flux-actions": "/flux-actions/static-1.306",
  "HubStyle": "/HubStyle/static-2.11517",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9997",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10159",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7108",
  "icons": "/icons/static-2.620",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17434",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4309",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4980",
  "quartz-i18n": "/quartz-i18n/static-1.387",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3517",
  "customer-data-objects": "/customer-data-objects/static-1.7433",
  "property-translator": "/property-translator/static-1.5199",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7711",
  "hs-promise-utils": "/hs-promise-utils/static-1.5378",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4666",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12790",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5373",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7574",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4261",
  "superstore": "/superstore/static-1.4557",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9931",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7425",
  "hub-http-janus": "/hub-http-janus/static-1.789",
  "hubspotter-http": "/hubspotter-http/static-1.4465",
  "immutable-less": "/immutable-less/static-1.4439",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16308",
  "nav-meta": "/nav-meta/static-1.28866",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10022",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17633",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3662",
  "property-management-common": "/property-management-common/static-1.4571",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8831",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.479",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.387",
  "quartz-head": "/quartz-head/static-1.377",
  "quartz-test": "/quartz-test/static-1.387",
  "quartz-tracking": "/quartz-tracking/static-1.91",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2933",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20254",
  "ContentUtils": "/ContentUtils/static-1.67587",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2270",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38865",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12792",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12929",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13464",
  "ExportDialog": "/ExportDialog/static-6.10174",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40627",
  "reporting-snowflake": "/reporting-snowflake/static-1.55077",
  "reporting-ui-components": "/reporting-ui-components/static-2.63730",
  "reporting-visualizations": "/reporting-visualizations/static-1.58535",
  "ui-addon-teams": "/ui-addon-teams/static-1.21223",
  "magpie-lib": "/magpie-lib/static-1.5380",
  "magpie-types": "/magpie-types/static-1.4840",
  "simple-logging-lib": "/simple-logging-lib/static-1.2836",
  "navigation-components": "/navigation-components/static-1.17229",
  "ai-studio-lib": "/ai-studio-lib/static-1.10966",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10251",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7774",
  "ui-tool-access": "/ui-tool-access/static-1.9931",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7971",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5535",
  "usage-tracker-public": "/usage-tracker-public/static-1.6929",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3404",
  "persist-promise": "/persist-promise/static-1.3492",
  "reference-resolvers": "/reference-resolvers/static-1.7947",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3732",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.125",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2786",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2155",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "atom": "/atom/static-1.4856",
  "purchase-motions-components": "/purchase-motions-components/static-1.5464",
  "salesImages": "/salesImages/static-1.520",
  "batch-promise": "/batch-promise/static-1.1335",
  "crm-component-utils": "/crm-component-utils/static-1.38455",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5658",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6657",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7879",
  "navigation-messaging": "/navigation-messaging/static-1.6556",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9448",
  "cms-field-types": "/cms-field-types/static-1.4591",
  "content-icons-ui": "/content-icons-ui/static-1.2148",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7034",
  "crm-message-bus": "/crm-message-bus/static-1.42329",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21299",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9611",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4516",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3820",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6562",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.759",
  "onboarding-tours": "/onboarding-tours/static-1.16238",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13001",
  "academy-common-lib": "/academy-common-lib/static-1.12924",
  "content-assistance-lib": "/content-assistance-lib/static-1.7429",
  "dashboard-lib": "/dashboard-lib/static-1.80580",
  "file-manager-components": "/file-manager-components/static-1.22854",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17850",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17574",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17566",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19450",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8478",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4552",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10691",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8812",
  "user-context": "/user-context/static-1.4882",
  "growth-payments-core": "/growth-payments-core/static-1.24696",
  "reporting-plugins": "/reporting-plugins/static-1.9966",
  "reporting-reports": "/reporting-reports/static-1.66137",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.511",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28832",
  "react-codemirror": "/react-codemirror/static-1.10413",
  "apps-service-types": "/apps-service-types/static-1.3665",
  "oauth-service-types": "/oauth-service-types/static-1.4028",
  "onboarding-scopes": "/onboarding-scopes/static-1.6249",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4452",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7479",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14572",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3439",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8524",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4301",
  "nav-client-types": "/nav-client-types/static-1.2142",
  "purchase-motions-api": "/purchase-motions-api/static-1.5467",
  "signup-constants": "/signup-constants/static-1.18362",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7854",
  "trials-service-types": "/trials-service-types/static-1.3702",
  "card-properties-lib": "/card-properties-lib/static-1.43485",
  "crm-actions": "/crm-actions/static-1.6086",
  "crm-cards-data": "/crm-cards-data/static-1.1184",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42879",
  "customer-data-properties": "/customer-data-properties/static-1.50768",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8777",
  "customer-data-tracking": "/customer-data-tracking/static-1.6667",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3610",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3951",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3504",
  "external-options-client-types": "/external-options-client-types/static-1.3971",
  "react-dnd-compat": "/react-dnd-compat/static-1.4408",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5138",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2856",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1286",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.304",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7312",
  "academy-service-client": "/academy-service-client/static-1.3467",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27912",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8171",
  "video-components-external": "/video-components-external/static-1.10526",
  "video-data-lib": "/video-data-lib/static-1.34184",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8355",
  "payment-link-components": "/payment-link-components/static-1.22909",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9675",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23883",
  "viral-links-lib": "/viral-links-lib/static-1.6819",
  "data-token-picker": "/data-token-picker/static-1.16022",
  "FileManagerLib": "/FileManagerLib/static-1.38494",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5031",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16968",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8236",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.176",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2983",
  "crm_data": "/crm_data/static-4.91176",
  "crm-links": "/crm-links/static-1.6049",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45384",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14980",
  "crm-fe-perf": "/crm-fe-perf/static-1.22691",
  "calling-global-api": "/calling-global-api/static-1.63611",
  "calling-internal-common": "/calling-internal-common/static-1.31077",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64993",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57287",
  "commerce-products-lib": "/commerce-products-lib/static-1.8828",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.463",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4036",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.419",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47928",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3773",
  "property-value-citations": "/property-value-citations/static-1.1382",
  "pulse": "/pulse/static-1.291",
  "smart-property-lib": "/smart-property-lib/static-1.5862",
  "tiered-pricing": "/tiered-pricing/static-1.810",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10780",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6371",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11412",
  "content-media-compositions": "/content-media-compositions/static-2.15419",
  "media-bridge-lib": "/media-bridge-lib/static-1.18544",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5699",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4873",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3462",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21288",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3631",
  "audio-components": "/audio-components/static-1.5593",
  "FileManagerCore": "/FileManagerCore/static-1.38353",
  "FileManagerImages": "/FileManagerImages/static-1.36005",
  "video-components": "/video-components/static-1.12529",
  "crm_universal": "/crm_universal/static-1.21641",
  "customer-data-email": "/customer-data-email/static-1.17649",
  "calling-error-reporting": "/calling-error-reporting/static-1.31083",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36472",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38827",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18470",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11123",
  "customer-data-content": "/customer-data-content/static-1.26851",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53982",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20839",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17112",
  "project-storage": "/project-storage/static-1.4518",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71122",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5302",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5115",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9533",
  "policy-lib": "/policy-lib/static-1.6569",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10823",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6325",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.210",
  "products-iframe-lib": "/products-iframe-lib/static-1.7280",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9832",
  "directed-graph": "/directed-graph/static-1.723",
  "event-emitter": "/event-emitter/static-1.733",
  "react-tinymce": "/react-tinymce/static-1.54584",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9596",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53710",
  "tinymce-plugins": "/tinymce-plugins/static-1.56824",
  "tinymce-themes": "/tinymce-themes/static-1.55680",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4319",
  "video-embed": "/video-embed/static-1.35018",
  "social-insights-client-types": "/social-insights-client-types/static-1.21289",
  "sequences-lib": "/sequences-lib/static-1.7671",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10133",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17884",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36404",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9762",
  "utility-belt": "/utility-belt/static-1.2328",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21968",
  "products-ui-components": "/products-ui-components/static-1.39347",
  "quotes-client-types": "/quotes-client-types/static-1.37210",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79841",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8882",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6704",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53998",
  "commerce-products-api": "/commerce-products-api/static-1.1939",
  "SafeStorage": "/SafeStorage/static-1.4190",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56056",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101798",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34987",
  "sales-views-client-types": "/sales-views-client-types/static-1.4078",
  "hub-http-contrib": "/hub-http-contrib/static-1.2831",
  "interframe": "/interframe/static-3.4577",
  "tinymce-data": "/tinymce-data/static-1.39795",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4999",
  "layout-dnd-components": "/layout-dnd-components/static-1.12011",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10986",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13826",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8883",
  "outpost": "/outpost/static-1.3991",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7528",
  "customer-data-associations": "/customer-data-associations/static-1.7123",
  "framework-data-table": "/framework-data-table/static-2.11384",
  "customer-data-rte": "/customer-data-rte/static-1.32417",
  "cv-backend-services": "/cv-backend-services/static-1.1499",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5346",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14192",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4898",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7112",
  "commerce-permissions": "/commerce-permissions/static-1.539",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.299",
  "property-description-translator": "/property-description-translator/static-1.3645",
  "FireAlarmUi": "/FireAlarmUi/static-1.4316",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3979",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3450",
  "totals-ui-components": "/totals-ui-components/static-1.22968",
  "ContentData": "/ContentData/static-1.67662",
  "layout-data-lib": "/layout-data-lib/static-1.9311",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1215",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27685",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3624",
  "advanced-menus-core": "/advanced-menus-core/static-1.14795",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11771",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33395",
  "deal-intel-utils": "/deal-intel-utils/static-1.1219",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14794",
  "simple-menus-lib": "/simple-menus-lib/static-1.16311"
}
};
